import {useMemo} from 'react';
import {
  RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY,
  RELATED_PRODUCTS_TAB_KEY_LOWER_MINIMUMS,
  RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES,
  RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND
} from 'constants/pdpRelatedProducts';

export const filterByCategory = (products, categoryId) => {
  if (!products || !categoryId) return products;
  return products.filter(
    (product) => product.primary_category_id === categoryId
  );
};

export const filterByBrand = (products, brand) => {
  if (!products) return products;
  if (!brand || brand === '') return [];
  return products.filter((item) =>
    item.brand?.find(
      (recoBrand) =>
        recoBrand !== '' && recoBrand.toLowerCase() === brand.toLowerCase()
    )
  );
};

export const getMinPrice = (product) => {
  return product.default_unit_prices.reduce(
    (min, value) => (value.price < min.price ? value : min),
    {price: Number.MAX_SAFE_INTEGER}
  );
};

export default function useRelatedProductsData({
  alternativeProducts,
  brand,
  minQty,
  primaryCategoryId,
  recoBrandProducts,
  recommendations,
  relatedProducts,
  relatedProductsActiveTab,
  shouldTabbedViewRender
}) {
  const tabbedViewProducts = useMemo(() => {
    if (!shouldTabbedViewRender) {
      return alternativeProducts.slice(0, 4);
    }

    let products;
    switch (relatedProductsActiveTab) {
      case RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES:
        products = relatedProducts?.complements;
        break;
      case RELATED_PRODUCTS_TAB_KEY_BUDGET_FRIENDLY:
        products = filterByCategory(
          recommendations?.related_products,
          primaryCategoryId
        );
        if (products) {
          products = [...products].sort(
            (a, b) => getMinPrice(a).price - getMinPrice(b).price
          );
        }
        break;
      case RELATED_PRODUCTS_TAB_KEY_MORE_FROM_THIS_BRAND:
        products = recoBrandProducts.brand_products || [];
        break;
      case RELATED_PRODUCTS_TAB_KEY_LOWER_MINIMUMS:
        products = filterByCategory(
          recommendations?.related_products,
          primaryCategoryId
        )
          ?.filter((product) => product.min_qty < minQty)
          ?.sort((a, b) => a.min_qty - b.min_qty);
        break;
      default:
        products = filterByCategory(
          recommendations?.related_products,
          primaryCategoryId
        );
    }
    return products;
  }, [
    relatedProductsActiveTab,
    recommendations,
    relatedProducts,
    shouldTabbedViewRender,
    alternativeProducts,
    brand,
    primaryCategoryId
  ]);

  return {
    filterByBrand,
    filterByCategory,
    getMinPrice,
    tabbedViewProducts
  };
}
